const imgUrl =
  "https://cdn.iconscout.com/icon/free/png-256/markdown-2-458334.png";
const initialInput = `### Heading 3
--- \n**bold text**\n\n---\n*italic text*\n\n---\n[Link Text](https://www.example.com)\n\n---\n
![This is an ALT image text](${imgUrl})\n\n---\n
- First item\n
- Second item\n
- Third item`;

export default initialInput;
